import styled from "styled-components"

const Container = styled.div`
  width: 100%;
  padding: 24px 18px;
  background: var(--surface-2);
  border-radius: 40px;

  &:last-child {
    margin-bottom: 0;
  }
}
`
const Title = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 16px;
  padding-left: 16px;
`

const WidgetRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px 16px;
`

interface Props {
  className?: string
  title: string
  children: React.ReactNode[]
}

export const WidgetsRowWrapper = ({ className, title, children }: Props) => {
  return (
    <Container className={className}>
      <Title>{title}</Title>
      <WidgetRow>{children}</WidgetRow>
    </Container>
  )
}
